var vA145 = [];
module.exports.estimateValue = function (p5816) {
  return vA145[p5816];
};
module.exports.update = function (p5817) {
  vA145 = p5817;
};
module.exports.change = function (p5818, p5819) {
  vA145[p5818] = p5819;
};
module.exports.get = function (p5820) {
  return vA145[p5820];
};
module.exports.dump = function () {
  return vA145;
};